import React from "react";
import browserHistory from "../utils/history";
import {ItemContainer, TileContainer, device} from "../resources/styles";
import styled, {useTheme} from "styled-components";
import {PropTypes} from "prop-types";
import DateTileContainer from "./DateTileContainer";
import {formatDateButtonDate, getDayOfWeek} from "../utils/dateTimeUtils";

const DayOfWeek = styled.div `
    display: none;
    @media ${device.tablet} {
        display: inline;
    }
`;

const Container = styled.div `
    background-color: white;
    height: 100%;
    text-align: center;
    border-radius: ${props => props.theme.tileBorderRadius || "0px"};
    cursor: pointer;
`;

const DateButton = ({link, linkId, scheduleId, date, disabled, index, title, subtitle, day, linkState}, context) => {

    const theme = useTheme();

    return (
        <TileContainer heightWidthRatio={theme.tileHeightWidthRatio || "100%"}>
            <ItemContainer onClick={() => browserHistory.push(`${link}/${linkId}`, linkState)}
                           disabled={disabled}
            >
                <Container>
                    <DateTileContainer index={index}
                        scheduleId={scheduleId}
                    >
                        { date ? (
                            <>
                                <div>{ formatDateButtonDate(date, theme.dateLocale) }</div>
                                <DayOfWeek>{ getDayOfWeek(date, "long") }</DayOfWeek>
                            </>
                        ):(
                            <div>{context.t('day')} {day}</div>
                        ) }
                        <div>{title}</div>
                        <div>{subtitle}</div>
                    </DateTileContainer>
                </Container>
            </ItemContainer>
        </TileContainer>
    )
};

DateButton.contextTypes = {
    t: PropTypes.func.isRequired
}

export default DateButton;
